module.exports = __webpack_public_path__ + "static/about_bg-7bb9849632955f2a149dce2a29f4e1bb.jpg";